import { commitSetter } from '@/utils/vuex';
import service from '@/services/email';

export default {
  // Setters
  setDestinationEmail: commitSetter('setDestinationEmail'),
  setReviewRequestFromEmail: commitSetter('setReviewRequestFromEmail'),
  setReviewRequestFromName: commitSetter('setReviewRequestFromName'),
  setReviewRequestSubject: commitSetter('setReviewRequestSubject'),
  setReviewRequestPreheader: commitSetter('setReviewRequestPreheader'),
  setCouponFromEmail: commitSetter('setCouponFromEmail'),
  setCouponFromFromName: commitSetter('setCouponEmailFromName'),
  setCouponFromSubject: commitSetter('setCouponSubject'),
  setCouponFromPreheader: commitSetter('setCouponPreheader'),
  setReviewRequestSMSFromName: commitSetter('setReviewRequestSMSFromName'),
  setReviewRequestSMSText: commitSetter('setReviewRequestSMSText'),
  setOrderPrinterText: commitSetter('setOrderPrinterText'),
  // Load Template
  loadEmailReviewrequestTemplate: ({ commit }, payload) => {
    return service
      .getEmailReviewrequestTemplate(payload)
      .then(response => {
        return commit('loadEmailReviewrequestTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadCountryEmailReviewrequestTemplates: ({ commit }, payload) => {
    const { advanced } = payload;
    return service
      .getCountryEmailReviewrequestTemplates(advanced)
      .then(response => {
        return commit('loadCountryEmailReviewrequestTemplatesSuccess', response);
      })
      .catch(() => {});
  },
  loadEmailCouponTemplate: ({ commit }, payload) => {
    return service
      .getEmailCouponTemplate(payload)
      .then(response => {
        return commit('loadEmailCouponTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadCountryEmailCouponTemplates: ({ commit }, payload) => {
    const { advanced } = payload;
    return service
      .getCountryEmailCouponTemplate(advanced)
      .then(response => {
        return commit('loadCountryEmailCouponTemplatesSuccess', response);
      })
      .catch(() => {});
  },
  loadEmailVerifyEmailTemplate: ({ commit }, payload) => {
    return service
      .getEmailVerifyEmailTemplate(payload)
      .then(response => {
        return commit('loadEmailVerifyEmailTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadCountryEmailVerifyEmailTemplate: ({ commit }, payload) => {
    const { advanced } = payload;
    return service
      .getCountryVerifyEmailRequestTemplate(advanced)
      .then(response => {
        return commit('loadCountryVerifyEmailRequestTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadPageTemplate: ({ commit }) => {
    return service
      .getPageTemplate()
      .then(response => {
        return commit('loadPageTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadEmailPhotoRequestTemplate: ({ commit }, payload) => {
    return service
      .getEmailPhotoRequestTemplate(payload)
      .then(response => {
        return commit('loadEmailPhotoRequestTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadCountryEmailPhotoRequestTemplate: ({ commit }, payload) => {
    const { advanced } = payload;
    return service
      .getCountryEmailPhotoRequestTemplate(advanced)
      .then(response => {
        return commit('loadCountryEmailPhotoRequestTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadSMSReviewrequestTemplate: ({ commit }) => {
    return service
      .getSmsReviewrequestTemplate()
      .then(response => {
        return commit('loadSMSReviewrequestTemplateSuccess', response);
      })
      .catch(() => {});
  },
  loadOrderPrinterTemplate: ({ commit }) => {
    return service
      .getOrderPrinterTemplate()
      .then(response => {
        return commit('loadOrderPrinterTemplateSuccess', response);
      })
      .catch(() => {});
  },

  // Settings
  loadSettingsEmailReviewrequest: ({ commit }) => {
    return service.getSettingsEmailReviewrequest().then(response => {
      return commit('loadSettingsEmailReviewrequestSuccess', response);
    });
  },
  loadSettingsEmailReviewrequestCountry: ({ commit }) => {
    return service.getSettingsEmailReviewrequestCountry().then(response => {
      return commit('loadSettingsEmailReviewrequestCountrySuccess', response);
    });
  },
  loadThxPageCountryTemplates: ({ commit }) => {
    return service.getThxPageCountry().then(response => {
      return commit('loadThxPageCountryTemplatesSuccess', response);
    });
  },
  loadSettingsSettingsCoupon: ({ commit }) => {
    return service.getSettingsCoupon().then(response => {
      return commit('loadSettingsSettingsCouponSuccess', response);
    });
  },
  loadSettingsSettingsCouponCountry: ({ commit }) => {
    return service.getSettingsCouponCountry().then(response => {
      return commit('loadSettingsSettingsCouponCountrySuccess', response);
    });
  },
  loadSettingsSmsCountry: ({ commit }) => {
    return service.getSettingsSmsCountry().then(response => {
      return commit('loadSettingsSmsCountrySuccess', response);
    });
  },
  loadSettingsVerifyEmail: ({ commit }) => {
    return service.getSettingsVerifyEmail().then(response => {
      return commit('loadSettingsVerifyEmailSuccess', response);
    });
  },
  loadSettingsVerifyEmailCountry: ({ commit }) => {
    return service.getSettingsVerifyEmailCountry().then(response => {
      return commit('loadSettingsVerifyEmailCountrySuccess', response);
    });
  },
  loadSettingsEmailPhotoRequest: ({ commit }) => {
    return service.getSettingsEmailPhotoRequest().then(response => {
      return commit('loadSettingsEmailPhotoRequestSuccess', response);
    });
  },
  loadSettingsEmailPhotoRequestCountry: ({ commit }) => {
    return service.getSettingsEmailPhotoRequestCountry().then(response => {
      return commit('loadSettingsEmailPhotoRequestCountrySuccess', response);
    });
  },
  updateSettingsEmailReviewrequest: ({ commit, dispatch }, payload) => {
    return service
      .postSettingsEmailReviewrequest(
        payload.fromEmail,
        payload.fromName,
        payload.subject,
        payload.preheader
      )
      .then(response => {
        return commit('updateSettingsEmailReviewrequestSuccess', response);
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  updateSettingsEmailCoupon: ({ commit, state }, payload) => {
    return service
      .postSettingsEmailCoupon(
        state.templatesCoupon.settings.fromEmail,
        state.templatesCoupon.settings.fromName,
        state.templatesCoupon.settings.subject,
        state.templatesCoupon.settings.preheader
      )
      .then(response => {
        return commit('updateSettingsEmailCouponSuccess', response, payload);
      })
      .catch(() => {});
  },
  updateSettingsEmailVerifyEmail: ({ commit }, payload) => {
    const { fromEmail, fromName, subject, preheader } = payload;
    return service
      .postSettingsEmailVerifyEmail(fromEmail, fromName, subject, preheader)
      .then(response => {
        return commit('updateSettingsEmailVerifyEmailSuccess', response, payload);
      })
      .catch(() => {});
  },
  updateSettingsEmailVerifyEmailCountry: ({ dispatch, commit }, payload) => {
    const {
      fromEmail,
      fromName,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    } = payload;
    return service
      .postSettingsEmailVerifyEmailCountry(
        fromEmail,
        fromName,
        subject,
        preheader,
        templateHtml,
        templateJson,
        country,
        copyFromCountry
      )
      .then(response => {
        commit('updateSettingsEmailVerifyEmailCountrySuccess', response, payload);
        return dispatch('loadSettingsVerifyEmailCountry');
      })
      .catch(() => {});
  },
  updateSettingsEmailPhotoRequest: ({ commit }, payload) => {
    const { fromEmail, fromName, subject, preheader } = payload;
    return service
      .postSettingsPhotoRequestEmail(fromEmail, fromName, subject, preheader)
      .then(response => {
        return commit('updateSettingsEmailPhotoRequestSuccess', response, payload);
      })
      .catch(() => {});
  },
  updateSettingsEmailPhotoRequestCountry: ({ dispatch, commit }, payload) => {
    const {
      fromEmail,
      fromName,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    } = payload;
    return service
      .postSettingsPhotoRequestEmailCountry(
        fromEmail,
        fromName,
        subject,
        preheader,
        templateHtml,
        templateJson,
        country,
        copyFromCountry
      )
      .then(response => {
        commit('updateSettingsEmailPhotoRequestCountrySuccess', response, payload);
        return dispatch('loadSettingsEmailPhotoRequestCountry');
      })
      .catch(() => {});
  },
  loadSettingsSMSReviewrequest: ({ commit }) => {
    return service.getSettingsSMSReviewrequest().then(response => {
      return commit('loadSettingsSMSReviewrequestSuccess', response);
    });
  },
  updateSettingsSMSReviewrequest: ({ commit }, payload) => {
    return service
      .postSettingsSMSReviewrequest(payload.fromName)
      .then(response => {
        return commit('updateSettingsSMSReviewrequestSuccess', response, payload);
      })
      .catch(() => {});
  },
  saveCountryThxPage: ({ commit }, payload) => {
    const { templateHtml, templateJson, country, copyFromCountry } = payload;
    return service
      .postSaveCountryThxPage(templateHtml, templateJson, country, copyFromCountry)
      .then(response => {
        return commit('updateThxPageCountrySuccess', response, payload);
      })
      .catch(() => {});
  },

  // Load Preview
  loadPreviewReviewrequest: ({ commit }) => {
    return service.getPreviewReviewrequest().then(response => {
      return commit('loadPreviewReviewrequestSuccess', response.data);
    });
  },
  loadPreviewCoupon: ({ commit }) => {
    return service.getPreviewCoupon().then(response => {
      return commit('loadPreviewCouponSuccess', response.data);
    });
  },
  loadPreviewVerifyEmail: ({ commit }) => {
    return service.getPreviewVerifyEmail().then(response => {
      return commit('loadPreviewVerifyEmailSuccess', response.data);
    });
  },
  loadPreviewPage: ({ commit }) => {
    return service.getPreviewPage().then(response => {
      return commit('loadPreviewPageSuccess', response.data);
    });
  },
  loadPreviewPhotoRequest: ({ commit }) => {
    return service.getPreviewPhotoRequest().then(response => {
      return commit('loadPreviewPhotoRequestSuccess', response.data);
    });
  },
  loadPreviewReviewrequestSMS: ({ commit }) => {
    return service.getPreviewReviewrequestSMS().then(response => {
      return commit('loadPreviewReviewrequestSMSSuccess', response.data);
    });
  },
  loadPreviewOrderPrinter: ({ commit }) => {
    return service.getPreviewOrderPrinter().then(response => {
      return commit('loadPreviewOrderPrinterSuccess', response.data);
    });
  },
  // Save design
  saveDesignReviewRequest: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate } = payload;
    return service
      .postDesignReviewRequest(templateJson, templateHtml, advancedTemplate)
      .then(response => {
        commit('loadPreviewReviewrequestSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignReviewRequestSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  updateSettingsEmailReviewrequestCountry: ({ dispatch, commit }, payload) => {
    const {
      fromEmail,
      fromName,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    } = payload;
    return service
      .postSettingsEmailReviewrequestCountry(
        fromEmail,
        fromName,
        subject,
        preheader,
        templateHtml,
        templateJson,
        country,
        copyFromCountry
      )
      .then(response => {
        commit('updateSettingsEmailReviewrequestCountrySuccess', response, payload);
        return dispatch('loadSettingsEmailReviewrequestCountry');
      })
      .catch(() => {});
  },

  updateSettingsEmailCouponCountry: ({ dispatch, commit }, payload) => {
    const {
      fromEmail,
      fromName,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    } = payload;
    return service
      .postSettingsEmailCouponCountry(
        fromEmail,
        fromName,
        subject,
        preheader,
        templateHtml,
        templateJson,
        country,
        copyFromCountry
      )
      .then(response => {
        commit('updateSettingsEmailCouponCountrySuccess', response, payload);
        return dispatch('loadSettingsSettingsCouponCountry');
      })
      .catch(() => {});
  },
  updateSettingsSMSCountry: ({ dispatch, commit }, payload) => {
    const {
      fromEmail,
      fromName,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    } = payload;
    return service
      .postCreateSMSTemplateCountry(
        fromEmail,
        fromName,
        subject,
        preheader,
        templateHtml,
        templateJson,
        country,
        copyFromCountry
      )
      .then(response => {
        commit('saveReviewRequestSMSSuccessCountry', response, payload);
        return dispatch('loadSettingsSmsCountry');
      })
      .catch(() => {});
  },
  saveDesignReviewRequestCountry: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate, country } = payload;
    return service
      .postDesignReviewRequestCountry(templateJson, templateHtml, advancedTemplate, country)
      .then(response => {
        commit(
          'loadPreviewReviewrequestCountrySuccess',
          response.data.data.renderedPreviewTemplate
        );
        return commit('saveDesignReviewRequestCountrySuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignCoupon: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate } = payload;
    return service
      .postDesignCoupon(templateJson, templateHtml, advancedTemplate)
      .then(response => {
        commit('loadPreviewCouponSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignCouponSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignCouponCountry: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate, country } = payload;
    return service
      .postDesignCouponCountry(templateJson, templateHtml, advancedTemplate, country)
      .then(response => {
        commit('loadPreviewCouponCountrySuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignCouponCountrySuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignVerifyEmail: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate } = payload;
    return service
      .postDesignVerifyEmail(templateJson, templateHtml, advancedTemplate)
      .then(response => {
        commit('loadPreviewVerifyEmailSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignVerifyEmailSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignVerifyEmailCountry: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate, country } = payload;
    return service
      .postDesignVerifyEmailCountry(templateJson, templateHtml, advancedTemplate, country)
      .then(response => {
        commit('loadPreviewVerifyEmailCountrySuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignVerifyEmailCountrySuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignThxPage: (_, payload) => {
    return service.postDesignThxPage(payload.templateJson, payload.templateHtml);
  },

  saveDesignPhotoRequest: ({ commit }, payload) => {
    return service
      .postDesignPhotoRequest(payload.templateJson, payload.templateHtml, payload.advancedTemplate)
      .then(response => {
        commit('loadPreviewPhotoRequestSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignPhotoRequestSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignPhotoRequestCountry: ({ commit }, payload) => {
    const { templateJson, templateHtml, advancedTemplate, country } = payload;
    return service
      .postDesignPhotoRequestCountry(templateJson, templateHtml, advancedTemplate, country)
      .then(response => {
        commit('loadPreviewPhotoRequestCountrySuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignPhotoRequestCountrySuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveDesignReviewRequestSMS: ({ commit }, payload) => {
    return service
      .postDesignReviewRequestSms(payload.templateJson, payload.templateHtml)
      .then(response => {
        commit('loadPreviewReviewrequestSMSSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignReviewRequestSMSSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  saveReviewRequestSMSCountry: ({ commit }, payload) => {
    return service
      .postReviewRequestSmsCountry(payload.country, payload.templateJson, payload.templateHtml)
      .then(response => {
        commit('loadPreviewReviewrequestSMSSuccess', response.data.data.renderedPreviewTemplate);
      })
      .catch(() => {});
  },
  saveDesignOrderPrinter: ({ commit }, payload) => {
    return service
      .postDesignOrderPrinter(payload.templateJson, payload.templateHtml)
      .then(response => {
        commit('loadPreviewOrderPrinterSuccess', response.data.data.renderedPreviewTemplate);
        return commit('saveDesignOrderPrinterSuccess', response.data, payload);
      })
      .catch(() => {});
  },

  // Send test email
  sendDestinationReviewRequest: ({ commit }, payload) => {
    return service
      .postDestinationReviewRequest(
        payload.destinationEmail,
        payload.advancedTemplate,
        payload.country
      )
      .then(response => {
        return commit('sendDestinationReviewRequestSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  sendDestinationCoupon: ({ commit }, payload) => {
    return service
      .postDestinationCoupon(payload.destinationEmail, payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('sendDestinationCouponSuccess', response.data, payload);
      });
  },
  sendDestinationVerifyEmail: ({ commit }, payload) => {
    return service
      .postDestinationVerifyEmail(
        payload.destinationEmail,
        payload.advancedTemplate,
        payload.country
      )
      .then(response => {
        return commit('sendDestinationVerifyEmailSuccess', response.data, payload);
      })
      .catch(() => {});
  },
  sendDestinationPhotoRequest: ({ commit }, payload) => {
    return service
      .postDestinationPhotoRequest(
        payload.destinationEmail,
        payload.advancedTemplate,
        payload.country
      )
      .then(response => {
        return commit('sendDestinationPhotoRequestSuccess', response.data, payload);
      })
      .catch(() => {});
  },

  // Reset template
  sendResetReviewRequest: ({ commit }, payload) => {
    return service
      .postResetReviewRequestDesign(payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('sendResetReviewRequestSuccess', response);
      })
      .catch(() => {});
  },
  sendResetCoupon: ({ commit }, payload) => {
    return service
      .postResetCouponDesign(payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('sendResetCouponSuccess', response);
      })
      .catch(() => {});
  },
  sendResetVerifyEmail: ({ commit }, payload) => {
    return service
      .postResetVerifyEmailDesign(payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('sendResetVerifyEmailSuccess', response);
      })
      .catch(() => {});
  },
  sendResetThxPage: ({ commit }, payload) => {
    return service
      .postResetThxPage(payload)
      .then(response => {
        return commit('sendResetThxPageSuccess', response);
      })
      .catch(() => {});
  },
  sendResetThxPageCountry: ({ commit }, payload) => {
    return service
      .postResetThxPageCountry(payload)
      .then(response => {
        return commit('sendResetThxPageSuccess', response);
      })
      .catch(() => {});
  },
  sendResetPhotoRequest: ({ commit }, payload) => {
    return service
      .postResetPhotoRequestDesign(payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('sendResetPhotoRequestSuccess', response);
      })
      .catch(() => {});
  },
  deleteReviewRequestCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deleteReviewRequestCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadSettingsEmailReviewrequestCountry');
      })
      .catch(() => {});
  },
  deleteCouponCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deleteCouponCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadSettingsSettingsCouponCountry');
      })
      .catch(() => {});
  },
  deletePhotoCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deletePhotoCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadSettingsEmailPhotoRequestCountry');
      })
      .catch(() => {});
  },
  deleteSmsCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deleteSmsCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadSettingsSmsCountry');
      })
      .catch(() => {});
  },
  deletePageCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deletePageCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadThxPageCountryTemplates');
      })
      .catch(() => {});
  },
  deleteVerifyEmailCountryTemplate: ({ dispatch }, payload) => {
    return service
      .deleteVerifyEmailCountryTemplate(payload.country)
      .then(() => {
        return dispatch('loadSettingsVerifyEmailCountry');
      })
      .catch(() => {});
  },
  sendResetReviewRequestSMS: ({ commit }, payload) => {
    return service
      .postResetReviewRequestSMSDesign(payload.advancedTemplate, payload.country)
      .then(response => {
        return commit('setReviewRequestSMSSuccess', response);
      })
      .catch(() => {});
  },
  sendResetOrderPrinter: ({ dispatch }, payload) => {
    return service
      .postResetOrderPrinterDesign(payload)
      .then(() => {
        dispatch('loadPreviewOrderPrinter');
        return dispatch('loadOrderPrinterTemplate');
      })
      .catch(() => {});
  },
  testReviewRequestFlow: ({ state, commit }) => {
    return service
      .postTestReviewRequestFlow(state.testFlow.email, state.testFlow.products)
      .then(response => {
        return commit('testReviewRequestFlowSuccess', response);
      })
      .catch(() => {});
  },
  loadReviewRequestTestOrder: ({ commit }) => {
    return service
      .getTestOrderData()
      .then(response => commit('loadReviewRequestTestOrderSuccess', response));
  },
};
